// extracted by mini-css-extract-plugin
export default {"sectionBorder":"form_sectionBorder__7jgPz"};